export class BackupPolicySecurityConfig {
    'id';
    'enabled';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "enabled",
            "baseName": "enabled",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BackupPolicySecurityConfig.attributeTypeMap;
    }
    constructor() {
    }
}
